function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M54.92 46.71C58.128 41.933 60 36.185 60 30 60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 3.015 0 5.927-.445 8.673-1.273"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1 1) translate(2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  stroke: "#656565",
  strokeLinecap: "round",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  mask: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#656565"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.482 0c1.023 3.255.427 5.58-1.788 6.976s-6.659 2.485-13.331 3.267",
  transform: "translate(-4 3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.43 5.121c-.386 3.147.057 5.986 1.33 8.518 3.231 6.43 10.539 15.81 9.897 19.062-.41 2.071-3.51.813-7.54 4.734-2.358 2.294 1.75 6.847-1.258 9.176-.878.68-2.954.353-6.182 0-1.013-.11-2.672.096-4.975.62M21.451 50.729c3.373-.41 5.645-.53 6.817-.36 1.516.22 2.965.324 3.325 1.28.383 1.015.11 2.474-.233 3.899-.308 1.286-.673 2.544-.66 3.423.023 1.721 1.02 3.615 0 4.985-.901 1.21-3.906 1.969-5.876 2.2-1.739.203-7.066.275-11.86-1.464C10.32 63.733 6 61.352 0 57.548M12.821 21.367c1.656 1.347 3.552 2.02 5.69 2.02 2.136 0 4.033-.673 5.688-2.02",
  transform: "translate(-4 3)"
}))), /*#__PURE__*/React.createElement("g", {
  stroke: "#656565"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.665.915C2.557 7.58.5 12.09.5 14.34c0 3.396 2.905 6.16 6.5 6.16s6.5-2.764 6.5-6.16c0-2.24-2.28-6.754-6.835-13.425z",
  transform: "translate(39 37)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M10.423 12c.55 1.407.485 2.643-.193 3.71-.679 1.066-1.755 1.624-3.23 1.674",
  transform: "translate(39 37)"
}))));

var SvgIconAllergyRhinitis = function SvgIconAllergyRhinitis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAllergyRhinitis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-allergy_rhinitis.0d1eda47.svg";
export { ForwardRef as ReactComponent };